export class CustomizationConfiguration {
    title: string = null;
    cssFilename: string = null;
    sections: Array<string> = [];
    startSection: string = null;
}
